import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import Container from "../../../shared/design/Container";

type CountUpProps = { to: number; suffix?: string };

const CountUp = ({ to, suffix = "" }: CountUpProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.2,
      ease: [0, 0, 0.2, 1],
      onUpdate: (v) => setVal(v),
    });
    return () => controls.stop();
  }, [inView, to]);

  const display =
    to >= 1000
      ? Math.round(val).toLocaleString()
      : Math.round(val).toString();

  return (
    <span ref={ref}>
      {display}
      {suffix}
    </span>
  );
};

const stats: { to: number; suffix?: string; label: string }[] = [
  { to: 62, label: "Guided expeditions" },
  { to: 38, label: "National parks" },
  { to: 2400, suffix: "+", label: "Happy wanderers" },
  { to: 100, suffix: "%", label: "Carbon offset" },
];

const Stats = () => {
  return (
    <Container className="grid grid-cols-2 gap-6 py-16 md:grid-cols-4">
      {stats.map((s) => (
        <div key={s.label}>
          <div className="font-serif text-[44px] font-normal leading-none text-secondary-400 md:text-[56px]">
            <CountUp to={s.to} suffix={s.suffix} />
          </div>
          <div className="mt-1 text-[13.5px] tracking-[0.03em] text-muted">
            {s.label}
          </div>
        </div>
      ))}
    </Container>
  );
};

export default Stats;
